export default [
  // *===============================================---*
  // *--------- ORGANISATIONS ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/organisation/list',
    name: 'apps-organisations',
    component: () => import('@/views/pages/organisations/organisation-list/OrganisationsList.vue'),
    meta: {
      pageTitle: 'Organisaties',
      action: 'read',
      resource: 'organisation',
    },
  },
  {
    path: '/organisation/edit/:id',
    name: 'apps-organisation-edit',
    component: () => import('@/views/pages/organisations/organisation-edit/OrganisationEdit.vue'),
    meta: {
      pageTitle: 'Organisatie',
      action: 'update',
      resource: 'organisation',
    },
  },
  // *===============================================---*
  // *--------- LOCATIONS ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/locations',
    name: 'app-locations-list',
    component: () => import('@/views/pages/locations/locations-list/LocationsList.vue'),
    meta: {
      pageTitle: 'Locaties',
      action: 'read',
      resource: 'organisation',
    },
  },
  {
    path: '/locations/edit/:id',
    name: 'app-locations-edit',
    component: () => import('@/views/pages/locations/locations-edit/LocationsEdit.vue'),
    meta: {
      pageTitle: 'Locatie',
      action: 'update',
      resource: 'organisation',
    },
  },
  // *===============================================---*
  // *--------- USER ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/users/list',
    name: 'apps-users-list',
    component: () => import('@/views/pages/user/users-list/UsersList.vue'),
    meta: {
      pageTitle: 'Gebruikers',
      resource: 'user',
      action: 'read',
    },
  },
  {
    path: '/apps/users/edit/:id',
    name: 'apps-users-edit',
    component: () => import('@/views/pages/user/users-edit/UsersEdit.vue'),
    meta: {
      pageTitle: 'Gebruiker',
      resource: 'user',
      action: 'update',
    },
  },
  // *===============================================---*
  // *--------- ACCOUNT SETTINGS ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/account/settings',
    name: 'account-setting',
    component: () => import('@/views/pages/account-setting/AccountSetting.vue'),
    meta: {
      pageTitle: 'Account',
      resource: 'account',
      action: 'read',
    },
  },
  // *===============================================---*
  // *--------- LOGS ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/log',
    name: 'apps-log',
    component: () => import('@/views/pages/log/Log.vue'),
    meta: {
      pageTitle: 'Audit log',
      resource: 'audit',
      action: 'read',
    },
  },
]
